// PDF React View
import ConfirmModal from "components/shared-components/ConfirmModal";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Col,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import {
  RELEASE_ISSUE_INVOICE_FAIL,
  RELEASE_ISSUE_INVOICE_SUCCESS,
} from "store/issue-invoice/actionTypes";
const SignHSMModal = props => {
  const dispatch = useDispatch();

  // Deny Release modal
  const [dateErrorRelease, setDateErrorRelease] = useState(null);
  const [modalDenyRelease, setModalDenyRelease] = useState(false);
  const toggleDenyReleaseModal = () => setModalDenyRelease(!modalDenyRelease);

  const {
    isOpen,
    toggle,
    transferData,
    resetDataFunc,
    releaseFunc,
    resetReleaseFunc,
    invoice_type,
    t,
    typeInvoiceAnother,
    isCreateAdjust,
    idAdjust,
  } = props;
  const issueInvoice = useSelector(state => state.issueInvoice);
  const { type, releaseIssueInvoice } = issueInvoice;
  const { addToast } = useToasts();
  const history = useHistory();
  const TYPE_SEND = {
    NOT_SEND: 0,
    SEND: 1,
  };

  const [typeSend, setTypeSend] = useState(TYPE_SEND.SEND);

  useEffect(() => {
    if (isOpen) {
    }
  }, [isOpen]);

  useEffect(() => {
    switch (type) {
      // SIGN HSM and release SUCCESS
      case RELEASE_ISSUE_INVOICE_SUCCESS:
        addToast(t("form.submit.release.success"), {
          appearance: "success",
          autoDismiss: true,
        });
        toggle();
        resetDataFunc();
        dispatch(resetReleaseFunc());
        // Tạo hóa đơn điều chỉnh giảm 100% ( từ HD doanh nghiệp)
        if (releaseIssueInvoice.adjustAll?.data?.id) {
          history.push(`/invoice/${releaseIssueInvoice.adjustAll?.data?.id}`);
        }
        if (location?.pathname === "/invoice/new") {
          history.push(`/invoice/all`);
        }
        break;
      case RELEASE_ISSUE_INVOICE_FAIL:
        addToast(t("form.submit.release.error"), {
          appearance: "error",
          autoDismiss: true,
        });
        setDateErrorRelease(releaseIssueInvoice.error);
        toggleDenyReleaseModal();
        dispatch(resetReleaseFunc());
        break;
      default:
        break;
    }
  }, [type]);

  return (
    <Modal
      size="sm"
      contentClassName="confirm-modal"
      isOpen={isOpen}
      role="dialog"
      style={{ maxWidth: "30%" }}
      autoFocus={true}
      centered={true}
      className="exampleModal"
      toggle={toggle}
    >
      {/* modalDenyRelease */}
      <ConfirmModal
        isOpen={modalDenyRelease}
        titleHeader={"Phát hành hóa đơn thất bại"}
        titleBody={dateErrorRelease}
        onConfirm={note => {
          toggleDenyReleaseModal();
        }}
        textBtnConfirm={"Xác nhận"}
        textBtnCancel={"Đóng"}
        toggle={toggleDenyReleaseModal}
      />
      <div className="modal-content">
        <ModalHeader toggle={toggle}>
          <Label>{t("signHSM.title")}</Label>
        </ModalHeader>
        <ModalBody>
          <Label className="font-size-14">
            {t("signHSM.content")}
            {isCreateAdjust && (
              <div className="text-primary">
                {" "}
                (Sau khi gửi phát hành thành công hóa đơn này sẽ tạo hóa đơn
                điều chỉnh giảm 100% cho hóa đơn khách hàng lẻ)
              </div>
            )}
          </Label>
          {invoice_type === "0" && (
            <React.Fragment>
              <Row>
                <Col>
                  <Label
                    style={{ cursor: "pointer" }}
                    className="d-flex align-items-center gap-1"
                  >
                    <input
                      type="radio"
                      name="typeSend"
                      value={typeSend}
                      checked={typeSend === TYPE_SEND.SEND}
                      onChange={() => {
                        setTypeSend(TYPE_SEND.SEND);
                      }}
                    ></input>
                    Chuyển đầy đủ nội dung từng hóa đơn.
                  </Label>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Label
                    style={{ cursor: "pointer" }}
                    className="d-flex align-items-center gap-1"
                  >
                    <input
                      type="radio"
                      name="typeSend"
                      value={typeSend}
                      checked={typeSend === TYPE_SEND.NOT_SEND}
                      onChange={() => {
                        setTypeSend(TYPE_SEND.NOT_SEND);
                      }}
                    ></input>
                    Chuyển theo bảng tổng hợp dữ liệu hóa đơn điện tử.
                  </Label>
                </Col>
              </Row>
            </React.Fragment>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            type="button"
            color="primary"
            // disabled={isDisableButton}
            className="me-2 btn-label"
            disabled={releaseIssueInvoice.loading}
            onClick={() => {
              dispatch(
                releaseFunc(
                  transferData.id,
                  typeSend,
                  typeInvoiceAnother,
                  null,
                  isCreateAdjust,
                  idAdjust
                )
              );
            }}
          >
            <i className="fas fa-signature label-icon" />
            {t("signHSM.sign")}
          </Button>
          <Button
            type="button"
            color="danger"
            className="me-2"
            onClick={toggle}
          >
            {t("signHSM.close")}
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  );
};

SignHSMModal.propTypes = {
  isCreateAdjust: PropTypes.any,
  idAdjust: PropTypes.any,
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  transferData: PropTypes.any,
  resetDataFunc: PropTypes.any,
  releaseFunc: PropTypes.func,
  resetReleaseFunc: PropTypes.func,
  invoice_type: PropTypes.any,
  t: PropTypes.any,
  typeInvoiceAnother: PropTypes.any,
};

export default SignHSMModal;
